@<template>
  <div>
    <div class="banner">
      <div class="banner-play">
        <System></System>
        <classification></classification>
        <hot-news style="float: right;"></hot-news>
      </div>
    </div>
<!--
    <contacts :contactsData="contactsData"></contacts>
-->

    <div class="content-bottom">
      <div class="content-bottom-play">
        <contacts :contactsData="contactsData"></contacts>
        <router-view></router-view>
      </div>
    </div>
    <div v-show="flag" class="changePasswordPopup">
      <change-password @closeChangePasswd="()=>flag = false"></change-password>
    </div>
  </div>
</template>

<script>
  import login from './components/login-old';
  import contacts from './components/contacts';
  import HotNews from "./components/hotNews";
  import System from "../system/components/system";
  import ChangePassword from "../changePassword/changePassword";
  import classification from "../classification/classification";

  export default {
    name:"index",
    components: {
      System,
      HotNews,
      login,
      contacts,
      ChangePassword,
      classification
    },
    data(){
      return{
        flag: false,
        // LatestNews: [],
        categoryNumber: 4,
        contactsData: '',
        loginCheck: '0',
      }
    },
    // computed: {
    //   ...mapState({
    //     LatestNews: (state) => state.LatestNews,
    //   }),
    // },
    methods:{
      async visitorIndex(){
        const json = await this.RequestUtil.request("/visitorIndex");
        if(json){
          if(json.statusCode == this.Constants.statusCode.ok){
            // this.LatestNews = json.datas.news;
            this.$store.commit('setLatestNews', json.datas.news)
            this.$store.commit('setClassification', json.datas.classification)
            this.contactsData = json.datas.contactsinfo;
          }
        }
      },
      async frontLoginCheck(){
        const json = await this.RequestUtil.request("/frontLoginCheck");
        if(json){
          if(json.statusCode == this.Constants.statusCode.ok){
            const isInitPasswd = json.datas.isInitPasswd;
            if(isInitPasswd == '1'){
              this.flag = true;
              this.$Message.warning({content: this.$t('i.login.isInitPasswd'),duration: 5});
              return;
            }else{
              const passwdExpired = json.datas.passwdExpired;
              if(passwdExpired == '1'){
                this.flag = true;
                this.$Message.warning({content: this.$t('i.login.passwdExpired'),duration: 5});
                return;
              }
            }
            this.loginCheck = '1';
          }else{
            this.loginCheck = '0';
          }
        }
      },
      setLoginCheck(val){
        this.loginCheck = val;
      }
    },
    async mounted () {
      this.$i18n.locale = localStorage.getItem("defaultLangValue");
    },
    async created(){
      this.visitorIndex();
      this.$i18n.locale = localStorage.getItem("defaultLangValue");
      let userInfo = localStorage.getItem("userInfo");
      let flag = true;
      this.loginCheck = '0';
      if(userInfo){
        let userInfoObj = JSON.parse(userInfo);
        if(userInfoObj){
          if(!(userInfoObj.isInitPasswd == '1' || userInfoObj.passwdExpired == '1')){
            flag = false;
            //await this.frontLoginCheck();
          }
        }
      }
      if(flag){
        await this.RequestUtil.request("/frontLogout");
      }
      this.$router.push({name:'majorfunction'});
    }
  }
</script>

<style scoped>
  .banner{
    width: 100%;
    /*height: 320px;*/
  }
  .banner-play{
    width: 1150px;
    /*height: 450px;*/
    margin: 0 auto;
    overflow: hidden;
    background-color: #fff;
  }
  .content-bottom{
    width: 100%;
    height: 443px;
  }
  .content-bottom-play{
    width: 1150px;
    height: 443px;
    margin: 0px auto;
  }
  .changePasswordPopup{
    position: absolute;
    z-index: 111;
  }
</style>



// WEBPACK FOOTER //
// src/pages/home/index.vue